import React from 'react';
import createReactClass from 'create-react-class';
import cx from 'classnames';
import _ from 'underscore';
import Icon from '../icon';
import { SpinnerHelper } from 'views/anyguide/helpers/spinner';
import './index.scss';

export default createReactClass({
  mixins: [SpinnerHelper],
  displayName: 'Button',
  getDefaultProps() {
    return {
      theme: 'grey',
      disabled: false,
      hidden: false,
    };
  },

  handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
    } else {
      if (this.props.location == undefined) {
        e.preventDefault();
      }

      if (typeof this.props.onClick === 'function') {
        return this.props.onClick.call(null, e);
      }
      return true;
    }
  },

  componentDidUpdate(prevProps) {
    if (this.props.loading && !prevProps.loading) {
      this.showSpinner();
    } else if (!this.props.loading && prevProps.loading) {
      this.hideSpinner();
    }
  },

  componentDidMount() {
    if (this.props.loading) {
      this.showSpinner();
    }
  },

  spinnerTarget() {
    return this.refs.button;
  },

  spinnerOptions() {
    return {
      lines: 10,
      length: 4,
      width: 3,
      radius: 9,
      color: '#FFF',
    };
  },

  render() {
    const buttonTheme = {};
    buttonTheme[`t-${this.props.theme}`] = true;
    buttonTheme['t-singleChild'] =
      this.props.icon &&
      !_.any(
        [this.props.label, this.props.children, this.props.iconAfter],
        _.identity
      );
    const buttonClasses = cx(
      _.extend(
        {
          Button: true,
          'is-disabled': this.props.disabled,
          'is-hidden': this.props.hidden,
          'is-loading': this.props.loading,
          'is-creating': this.props.isCreating,
          'tour-step-button': this.props.createTourStepsButton,
        },
        buttonTheme
      )
    );

    return (
      <a
        href={this.props.location}
        target={this.props.target}
        className={buttonClasses}
        onClick={this.handleClick}
        ref="button"
        data-testid={this.props.dataTestId}
      >
        {this.props.icon ? <Icon icon={this.props.icon} /> : null}

        <span className="Button-label" data-testid="button-label">
          {this.props.label ? this.props.label : this.props.children}
        </span>

        {this.props.iconAfter ? <Icon icon={this.props.iconAfter} /> : null}
      </a>
    );
  },
});
